import { cn } from '@/lib/utils';

// A tool's real output, MOVING, wherever the tool is listed (owner
// 2026-10-16: "it shouldnt just show a image ... it should show the result of
// the tool moving and glowing in all places"). Muted, looping, inline, so
// phones autoplay it; the poster shows until the first frame. A vertical
// clip stands upright on a blurred wash of itself instead of being sliced
// into a wide frame.
export function LiveSample({ poster, src, upright = true, gallery, className }: { poster: string; src?: string; upright?: boolean; gallery?: readonly { src: string; poster: string }[]; className?: string }) {
  const media = 'transition-transform duration-700 group-hover:scale-[1.03]';
  if (gallery && gallery.length > 1) {
    // Every example at once (owner 2026-10-16: "it should show all of the examples at one time").
    return (
      // Up to four across; eight make two equal rows instead of thin slivers.
      <span className={cn('absolute inset-0 grid gap-1 bg-black p-1', gallery.length > 4 ? 'grid-cols-4 grid-rows-2' : 'grid-flow-col auto-cols-fr', className)}>
        {gallery.slice(0, 8).map((g) => (
          <video key={g.src} src={g.src} poster={g.poster} autoPlay muted loop playsInline preload="metadata" aria-hidden className={cn('h-full w-full min-w-0 rounded-md object-cover', media)} />
        ))}
      </span>
    );
  }
  return (
    <>
      {upright && <img src={poster} alt="" aria-hidden loading="lazy" decoding="async" className="absolute inset-0 h-full w-full scale-110 object-cover opacity-55 blur-2xl" />}
      {src ? (
        <video
          src={src}
          poster={poster}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          aria-hidden
          className={cn(upright ? 'relative mx-auto h-full w-auto max-w-full object-contain shadow-[0_18px_40px_rgba(0,0,0,0.6)]' : 'h-full w-full object-cover', media, className)}
        />
      ) : (
        <img
          src={poster}
          alt=""
          loading="lazy"
          decoding="async"
          className={cn(upright ? 'relative mx-auto h-full w-auto max-w-full object-contain shadow-[0_18px_40px_rgba(0,0,0,0.6)]' : 'h-full w-full object-cover', media, className)}
        />
      )}
    </>
  );
}
